import Logo from "assets/images/logo.png";
import Profile from "containers/SideBarTopMenuHOC/Profile";
import LanguageSelector from "containers/SideBarTopMenuHOC/LanguageSelector";
import LocationUrl from "components/common/LocationUrl";
import StoreSelector from "containers/SideBarTopMenuHOC/StoreSelector";
import HamburgerHeaderIcon from "components/icons/HamburgerHeaderIcon";
import s from "./styles";

function Header({ showingSecondarySider, setOpenSideBar, showThingsHeader }) {
  return (
    <s.HeaderContainer>
      {showThingsHeader && (
        <s.LeftElementsSmallScreen>
          <s.LocationTitle
            onClick={() => showingSecondarySider && setOpenSideBar()}
            style={{ cursor: showingSecondarySider && "pointer" }}
          >
            {showingSecondarySider && (
              <HamburgerHeaderIcon style={{ marginRight: "16px" }} />
            )}
            <LocationUrl />
          </s.LocationTitle>
        </s.LeftElementsSmallScreen>
      )}

      <s.LeftElements>
        <s.LocationTitle
          onClick={() => showingSecondarySider && setOpenSideBar()}
          style={{ cursor: showingSecondarySider && "pointer" }}
        >
          {showingSecondarySider && (
            <HamburgerHeaderIcon style={{ marginRight: "16px" }} />
          )}
          <LocationUrl />
        </s.LocationTitle>
        <StoreSelector />
      </s.LeftElements>

      <s.LogoContainer alt="logo" src={Logo} />
      <s.RightElements>
        <s.VerticalSeparator />
        <Profile />
        <LanguageSelector style={{ marginLeft: "40px" }} />
      </s.RightElements>
    </s.HeaderContainer>
  );
}

export default Header;
